import React from 'react';

var PlaceholderImage = ({imageClass, key}) => (
  <img className={'pic__img pic__img--placeholder ' + imageClass}
       key={key}
       src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
  />
);

export default PlaceholderImage;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Helpers/Pic/_PlaceholderImage.js
 **/